// extracted by mini-css-extract-plugin
module.exports = {"root":"ViewStoryButtonStyles__root view-story font-size--button--medium font-style--button-1 colors__brandPrimary--background-color"};
    if(module.hot) {
      // 1790535731829
      var cssReload = require("/var/lib/jenkins/workspace/Player_master/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  